import { FC } from "react";

import { Button } from "@/components/_atoms/button";
import { cn } from "@/lib/cn";

import { SidebarIcon } from "./sidebar-icon";

interface SidebarToggleButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  openLabel: string;
  closeLabel: string;
  flip?: boolean;
  isDisabled?: boolean;
  id?: string;
  className?: string;
}

export const SidebarToggleButton: FC<SidebarToggleButtonProps> = ({
  isOpen,
  onToggle,
  openLabel,
  closeLabel,
  flip = false,
  isDisabled = false,
  id,
  className,
}) => {
  return (
    <Button
      id={id}
      variant="outline"
      size="icon"
      onClick={onToggle}
      disabled={isDisabled}
      aria-label={isOpen ? closeLabel : openLabel}
      aria-expanded={isOpen}
      className={cn("shrink-0 rounded-md text-foreground/70", className)}
    >
      <SidebarIcon className={cn("h-4 w-4", flip && "-scale-x-100")} />
    </Button>
  );
};
